import _countries from "./json/countries.json";
import _currency from "./json/currency.json";
import _timezone from "./json/timezone.json";
import _regions from "./json/regions.json";
import _verticals from "./json/verticals.json";
import _module_plans from "./json/module_plans.json";
import _atlas_search_config from "./json/atlas_search.json";
import zuper_pay_countries from './json/countries.zuper_pay.json';

const countries = _countries.sort((a, b) => {
  return a.label.localeCompare(b.label);
});
const currencies = _currency.sort((a, b) => {
  return a.currencyName.localeCompare(b.currencyName);
});

const timezones = _timezone.sort((a, b) => {
  return a.display_name.localeCompare(b.display_name);
});

const regions = (
  process.env.REACT_APP_ENV === "production" ? _regions?.prod : _regions?.stag
)
  ?.filter((data) => {
    return data.public;
  })
  .sort((a, b) => {
    return a.full_name.localeCompare(b.full_name);
  });

const verticals = _verticals.sort((a, b) => {
  return a.label.localeCompare(b.label);
});

const userAgents = ["Web V3", "Web V2", "Mobile"];

const tokenValidities = [15, 30, 60];

const extendedValidities = [
  {
    key: 280,
    value: "4 hours",
  },
  {
    key: 720,
    value: "12 hours",
  },
  {
    key: 1440,
    value: "1 day",
  },
];
const loginAsUserReasons = [
  {
    reason: "Demo",
    free_text_required: false,
  },
  {
    reason: "Account Setup",
    free_text_required: false,
  },
  {
    reason: "Issue Testing",
    free_text_required: true,
  },
];

const zuper_connect_form = [
  {
    "label": "Call",
    "type": "group",
    "fields": [
      {
        "label": "Enable Call",
        "key": "zuper_connect.voice.is_enabled",
        "type": "toggle",
        "required": false,
        "attributes": {
          "className": "col-span-3"
        },
        "fields": [],
        "className": "col-span-3 mb-2"
      },
      {
        "label": "Max Softphone Users",
        "key": "zuper_connect.voice.max_softphone_users",
        "type": "number",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": [],
      },
      {
        "label": "Call Minutes Per Month",
        "key": "zuper_connect.voice.calls_limit",
        "type": "number",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": [],
      },
      {
        "label": "Max Phone Numbers",
        "key": "zuper_connect.phone_number.max_numbers",
        "type": "number",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "Supported Countries - Dialer",
        "key": "zuper_connect.phone_number.country_supported",
        "type": "chip-list",
        "required": false,
        "options": [
          {
            "key": "US",
            "label": "USA"
          },
          {
            "key": "CA",
            "label": "Canada"
          },
          {
            "key": "IN",
            "label": "India"
          }
        ],
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "Max Call Groups",
        "key": "zuper_connect.voice.max_call_groups",
        "type": "number",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "Max Mins Per Call",
        "key": "zuper_connect.voice.max_mins_per_call",
        "type": "number",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "Call Recording Retention (days)",
        "key": "zuper_connect.voice.call_recording_retention",
        "type": "number",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "Call Masking",
        "key": "zuper_connect.voice.call_masking",
        "type": "toggle",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "Sidekick",
        "key": "zuper_connect.voice.sidekick_enabled",
        "type": "toggle",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "Attribution",
        "key": "zuper_connect.phone_number.call_attributions",
        "type": "toggle",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "Analytics",
        "key": "zuper_connect.voice.call_analytics",
        "type": "toggle",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.is_enabled",
            false
          ]
        },
        "fields": []
      }
    ]
  },
  {
    "label": "Message",
    "type": "group",
    "fields": [
      {
        "label": "Enable Message",
        "key": "zuper_connect.messaging.is_enabled",
        "type": "toggle",
        "required": false,
        "attributes": {
          "className": "col-span-3"
        },
        "fields": [],
        "className": "col-span-3"
      },
      {
        "label": "SMS Per Month",
        "key": "zuper_connect.messaging.sms_limit",
        "type": "number",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.messaging.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.messaging.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "MMS Per Month",
        "key": "zuper_connect.messaging.mms_limit",
        "type": "number ",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.messaging.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.messaging.is_enabled",
            false
          ]
        },
        "fields": []
      },
      {
        "label": "UCC",
        "key": "zuper_connect.voice.ucc_enabled",
        "type": "toggle",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.messaging.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.messaging.is_enabled",
            false
          ]
        },
        "fields": []
      },
    ]
  },
  {
    "label": "AI",
    "type": "group",
    "fields": [
      {
        "label": "AI Responder",
        "key": "zuper_connect.voice.ai_responder.is_enabled",
        "type": "toggle",
        "required": false,
        "className": "col-span-1",
        "fields": []
      },
      {
        "label": "Call Summary/Transcript and Sentiment Analysis",
        "key": "zuper_connect.voice.call_transcription",
        "type": "toggle",
        "required": false,
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.ai_responder.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.ai_responder.is_enabled",
            false
          ]
        },
        "fields": [],
        "className": "col-span-2"
      },
      {
        "label": "AI Responder Per Call Minute Limitation",
        "key": "zuper_connect.voice.ai_call_limit",
        "type": "number",
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.ai_responder.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            true,
            true
          ]
        },
        "required": false,
      },
      {
        "label": "AI Call Summary/Transcript",
        "key": "zuper_connect.voice.call_transcription_limit",
        "type": "number",
        "hideInView": {
          "$eq": [
            "zuper_connect.voice.ai_responder.is_enabled",
            false
          ]
        },
        "disableWhen": {
          "$eq": [
            "zuper_connect.voice.ai_responder.is_enabled",
            false
          ]
        },
        "required": false,
        "className": "col-span-2"
      },
    ]
  }
];

const ZuperProV3URL =
  process.env.REACT_APP_ENV === "production"
    ? "https://web.zuperpro.com"
    : "https://stagingv3.zuperpro.com";

const ZuperProV2URL =
  process.env.REACT_APP_ENV === "production"
    ? "https://app.zuperpro.com"
    : "https://staging.zuperpro.com";

const CompanyStatus = ["SALE", "ONBOARDING", "HYPERCARE", "LIVE", "ARCHIVED"];

const coworkerRoles = ["CS", "ADMIN", "SUPERADMIN"];

export {
  countries,
  currencies,
  extendedValidities,
  zuper_connect_form,
  regions,
  timezones,
  tokenValidities,
  userAgents,
  verticals,
  loginAsUserReasons,
  _module_plans as module_plans,
  ZuperProV3URL,
  ZuperProV2URL,
  CompanyStatus,
  coworkerRoles,
  zuper_pay_countries
};
